import ListItem from '../utils/ListItem';

function ChartsListItem(props) {
  return (
    <ListItem
      to={{ pathname: props.link, from: window.location.pathname + window.location.search }}
      primary={props.descr}
      secondary={props.source}
    />
  );
}

export default ChartsListItem;
